import { defaultRehypePlugins, type StreamdownProps } from "streamdown";
import { PREFIJOS_IMAGEN_PERMITIDOS } from "@/lib/imagenesChat";

/*
 * Los rehypePlugins por defecto de Streamdown (`raw`, `sanitize`, `harden`, en
 * ese orden y tal cual los exporta `streamdown`) cambiando SOLO las opciones de
 * rehype-harden para las imagenes. No se usa el prop `security` de
 * @assistant-ui/react-streamdown a proposito: reconstruye la cadena con el
 * esquema de sanitize GENERICO y se perderian los ajustes de Streamdown (enlaces
 * `tel:`, `metastring` de los bloques de codigo). Constante de modulo: Streamdown
 * cachea el procesador por la identidad de los plugins.
 */
type Plugin = [unknown, Record<string, unknown>];
const [harden, opcionesHarden] = defaultRehypePlugins.harden as unknown as Plugin;

export const REHYPE_PLUGINS_CHAT = [
  defaultRehypePlugins.raw,
  defaultRehypePlugins.sanitize,
  [
    harden,
    {
      ...opcionesHarden,
      // rehype-harden EXIGE un origen por defecto en cuanto hay prefijos
      // concretos (sin el, lanza al montar el procesador y no se pinta ningun
      // mensaje). Solo resuelve URLs relativas: una imagen relativa resuelve
      // contra la propia UI, que no esta en la lista, y se bloquea.
      defaultOrigin: typeof window !== "undefined" ? window.location.origin : "https://sonia.fonestar.com",
      allowedImagePrefixes: [...PREFIJOS_IMAGEN_PERMITIDOS],
      allowDataImages: false,
      // Imagen bloqueada -> su texto alternativo; sin alt, nada. Sin el aviso en
      // ingles ("[Image blocked: ...]") que pinta la politica por defecto.
      imageBlockPolicy: "text-only",
    },
  ],
] as NonNullable<StreamdownProps["rehypePlugins"]>;
